var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sells-list"},_vm._l((_vm.sells),function(sell){return _c('ClientGoodsListItem',{key:sell.id,staticClass:"sells-item",attrs:{"sell":sell,"id":sell.id}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }